module.exports = __webpack_public_path__ + "img/alert_delivered.91264374.svg";